import styled from 'styled-components'
import { ColumnFlex } from '~/components/common/containers'

export const ItemContent = styled.div`
  width: 100%;

  ${ColumnFlex} {
    span:first-child {
      margin-bottom: 2px;
    }
  }

  ${ColumnFlex}:not(:first-child) {
    margin-top: 16px;
  }
`
